module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal-history-guest"
  }, [_c('div', {
    staticClass: "background-modal-guest"
  }, [_c('div', {
    staticClass: "container-modal"
  }, [_c('div', {
    staticClass: "section-history-guest"
  }, [_c('table-run', {
    staticClass: "no-selectable-table",
    attrs: {
      "selectable": false,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-options": true,
      "include-search": false,
      "include-switch": false,
      "include-settings": true,
      "include-delete-single": false,
      "columns": _vm.columns,
      "rows": _vm.rows
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.hour))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.product))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.gast))])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-end": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "mt-5": "",
      "align-right": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-cancel green",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n\t\t\t\t\tCerrar\n\t\t\t\t\t\t")])], 1)], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e92b557","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/guest/modal-history-guest.vue
// module id = 1625
// module chunks = 61